var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{attrs:{"router":"","to":{ name: 'lotform', params: { id: _vm.lot.id } },"color":_vm.cmpColor}},[_c('v-list-item-avatar',[_c('v-img',{attrs:{"src":_vm.lotImage}})],1),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.lot.title))]),_c('v-list-item-subtitle',[_vm._v(_vm._s(_vm.lot.stock_no))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }